import { render } from "./DeliveryHistory.vue?vue&type=template&id=48c9beb6&ts=true"
import script from "./DeliveryHistory.vue?vue&type=script&lang=ts"
export * from "./DeliveryHistory.vue?vue&type=script&lang=ts"

import "./DeliveryHistory.vue?vue&type=style&index=0&id=48c9beb6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__